import { Component, OnInit, Input } from '@angular/core';
import { ImprovementPlanProcess } from '../../models';


@Component({
  selector: 'process-details',
  templateUrl: './process-details.component.html',
  styleUrls: ['./process-details.component.scss'],
})
export class ProcessDetailsComponent implements OnInit {
  @Input() index: number = 0;
  @Input() process: ImprovementPlanProcess;
  constructor() {}

  ngOnInit() {}
  get_Risks() {
    return this.process.risk
      ? this.process.risk.split('//').map((x) => {
          return x;
        })
      : [];
  }
}
